export type AccountingLevel = 'single' | 'multi';

import { CurrencyCode } from '../config/currency';

/**
 * Types d'unités comptables alignés avec BusinessUnit
 * - company: Entreprise (niveau 0)
 * - branch: Succursale (niveau 1)
 * - pos: Point de vente (niveau 2)
 */
export type AccountingUnitType = 'company' | 'branch' | 'pos';

/**
 * Mapping des types AccountingUnit vers les niveaux hiérarchiques BusinessUnit
 * Permet la conversion sans affecter les endpoints existants
 */
export const ACCOUNTING_UNIT_HIERARCHY_LEVEL: Record<AccountingUnitType, number> = {
  company: 0,
  branch: 1,
  pos: 2
};

export const ACCOUNTING_UNIT_LABELS: Record<AccountingUnitType, string> = {
  company: 'Entreprise',
  branch: 'Succursale',
  pos: 'Point de vente'
};

export interface AccountingUnit {
  id: string;
  name: string;
  code: string;
  parentId?: string;
  type: AccountingUnitType;
  currency: CurrencyCode;
  isConsolidated: boolean;
  hierarchyLevel?: number;  // Niveau dans la hiérarchie (0=company, 1=branch, 2=pos)
}

export interface AccountingLevelSettings {
  type: AccountingLevel;
  consolidation: boolean;
  mainCurrency: CurrencyCode;
  units: AccountingUnit[];
  consolidationRules?: {
    eliminateIntercompany: boolean;
    convertCurrency: boolean;
    adjustments: boolean;
  };
}